module.exports = __webpack_public_path__ + "img/SIP_logo@2x.be80d115.png";